export default "__VITE_ASSET__DtlYYxzG__";